import { render, staticRenderFns } from "./NsbVideoCall.vue?vue&type=template&id=1a5ea866&scoped=true&"
import script from "./NsbVideoCall.vue?vue&type=script&lang=js&"
export * from "./NsbVideoCall.vue?vue&type=script&lang=js&"
import style0 from "./NsbVideoCall.vue?vue&type=style&index=0&id=1a5ea866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5ea866",
  null
  
)

export default component.exports